import React from 'react';
import { useTranslation } from 'react-i18next';

const StatusBadge = ({ status, size = 'sm' }) => {
  const { t } = useTranslation();

  const getStatusConfig = (statusValue) => {
    switch (statusValue) {
      case 'active-seeker':
        return {
          label: t('candidates.statusActiveSeeker'),
          className: 'bg-green-100 text-green-800 border-green-200'
        };
      case 'potential-seeker':
        return {
          label: t('candidates.statusPotentialSeeker'),
          className: 'bg-lime-100 text-lime-900 border-lime-200'
        };
      case 'pending':
        return {
          label: t('candidates.statusPending'),
          className: 'bg-amber-100 text-amber-800 border-amber-200'
        };
      case 'stable':
        return {
          label: t('candidates.statusStable'),
          className: 'bg-gray-100 text-gray-800 border-gray-200'
        };
      case 'unavailable':
        return {
          label: t('candidates.unknown'),
          className: 'bg-red-50 text-red-700 border-red-300'
        };
      default:
        return {
          label: t('candidates.unknown'),
          className: 'bg-gray-100 text-gray-800 border-gray-200'
        };
    }
  };

  const config = getStatusConfig(status);
  const sizeClass = size === 'md'
    ? 'px-3 py-1 text-sm'
    : 'px-2.5 py-0.5 text-xs';

  return (
    <span className={`inline-flex items-center rounded-full font-medium border ${sizeClass} ${config?.className}`}>
      {config?.label}
    </span>
  );
};

export default StatusBadge;
